import { useEffect } from 'react';
import { useOrganizationControllerGetPublicInfo } from '../../v2/api/generated/organizations/organizations';
import type { OrganizationResponseDto } from '../../v2/api/generated/types';
import PatientOrgContainer from './PatientOrgContainer';

interface UsePatientOrgDataProps {
  organizationId: number | null;
}

export function usePatientOrgData({ organizationId }: UsePatientOrgDataProps) {
  const container = PatientOrgContainer.useContainer();

  // Fetch organization public info using V2 REST API (no authentication required)
  const { data: organizationData, isLoading } = useOrganizationControllerGetPublicInfo(
    String(organizationId),
    {
      query: {
        enabled: !!organizationId,
      },
    },
  );

  // Sync API data to container state
  useEffect(() => {
    if (organizationData) {
      const actualData: OrganizationResponseDto | undefined =
        (organizationData as any)?.data?.data ||
        (organizationData as any)?.data ||
        organizationData;

      if (actualData) {
        container.setOrganizationId(actualData.id || null);
        container.setOrgName(actualData.name || '');

        // Organization logo
        const orgLogo = actualData.logoUrl || null;
        container.setLogoUrl(orgLogo);
      }
    }
  }, [organizationData, container]);

  useEffect(() => {
    container.setIsLoading(isLoading);
  }, [isLoading, container]);

  return {
    isLoading,
  };
}
